import { gql } from "graphql-tag";

export const campaignBannerV2 = gql`
  fragment Become_a_member_Campaign_Banner_V2 on Become_a_memberBodyCampaign_banner_v2 {
    type
    variation {
      ... on Become_a_memberBodyCampaign_banner_v2Default {
        primary {
          campaign_sale {
            ... on Campaign_sale1 {
              _meta {
                uid
              }
            }
          }
        }
      }
    }
  }
`;
